(() => {
  'use strict';
  if (window.__damaAnalyticsStarted) return;
  window.__damaAnalyticsStarted = true;
  const streams = { 'damacouture.de': 'G-7R50K9SP81', 'damacouture.pl': 'G-CFFWC1HRBT', 'damacouture.co.uk': 'G-B6P9MRGVSJ', 'damacouture.com': 'G-9YGH05NTTR', 'damacouture.it': 'G-9YGH05NTTR', 'damacouture.fr': 'G-9YGH05NTTR', 'damacouture.es': 'G-9YGH05NTTR' };
  const host = window.location.hostname.replace(/^www\./, '').toLowerCase();
  const stream = streams[host];
  const tagId = stream === 'G-9YGH05NTTR' ? 'GT-573CMHWJ' : stream;
  // Read only an existing opt-in marker; adding/removing it takes effect after reload.
  const internalBrowser = (() => {
    try { return document.cookie.split(';').some(value => value.trim() === 'dama_internal_browser=1'); }
    catch (_) { return false; }
  })();
  const internalTrafficParameters = () => internalBrowser ? { traffic_type: 'internal' } : {};
  const sourceTypes = new Set(['product', 'collection', 'homepage', 'navigation', 'brand', 'article', 'local', 'finder', 'direct', 'other']);
  const names = new Set(['dama_finder_opened', 'dama_salon_selected', 'dama_salon_contact_clicked', 'view_item', 'availability_view', 'check_boutique_availability', 'availability_country_open', 'salon_map_click', 'go_to_store_finder', 'store_finder_filter', 'salon_phone_click', 'salon_site_click']);
  const campaignKey = 'dama_kampania';
  const campaignFields = ['source', 'medium', 'campaign', 'content', 'term', 'id'];
  // Ad landing attribution waits in this tab (max 30 min) until the visitor decides on consent,
  // so a consent click on a later page still credits the ad. Cleared on refusal and once GA4 has it.
  const landingKey = 'dama_wejscie';
  const landingTtl = 30 * 60 * 1000;
  const landingIds = ['gclid', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid'];
  function readLanding() {
    try {
      const value = JSON.parse(sessionStorage.getItem(landingKey) || 'null');
      return value && typeof value === 'object' && Date.now() - value.t < landingTtl ? value : null;
    } catch (_) { return null; }
  }
  function clearLanding() { try { sessionStorage.removeItem(landingKey); } catch (_) {} }
  const cleanText = value => {
    const text = String(value || '').trim();
    return text && text.length <= 100 && !/[@<>\r\n]|https?:/i.test(text) ? text : '';
  };
  function marketingAllowed() {
    try { return !blocked() && usablePage() && privacy?.marketingAllowed() === true; } catch (_) { return false; }
  }
  function clearCampaign() { try { sessionStorage.removeItem(campaignKey); } catch (_) {} }
  // Only persist attribution after the relevant processing permission is available.
  // A new campaign URL wins over an earlier campaign in the same tab.
  function campaign(purpose = 'analytics') {
    if (purpose === 'marketing' ? !marketingAllowed() : !(allowed() && usablePage())) return {};
    const params = new URLSearchParams(window.location.search);
    let value = {};
    const tagged = campaignFields.some(key => params.has(`utm_${key}`)) || params.has('fbclid') || params.has('gclid') ||
      (host === 'damacouture.de' && ['gbraid', 'wbraid', 'ttclid'].some(key => params.has(key)));
    if (tagged) {
      for (const key of campaignFields) {
        const text = cleanText(params.get(`utm_${key}`));
        if (text) value[`dama_${key}`] = text;
      }
      if (params.has('fbclid')) { value.dama_klik = 'fbclid'; value.dama_source ||= 'meta'; }
      if (params.has('gclid')) { value.dama_klik = 'gclid'; value.dama_source ||= 'google'; }
    } else {
      // A fresh external arrival must not inherit the previous tab's custom campaign.
      let reuse = true;
      if (host === 'damacouture.de' && document.referrer) {
        try { reuse = new URL(document.referrer).hostname.replace(/^www\./, '').toLowerCase() === host; }
        catch (_) { reuse = false; }
      }
      if (reuse) {
        try { value = JSON.parse(sessionStorage.getItem(campaignKey) || '{}'); } catch (_) { value = {}; }
      }
      if (!Object.keys(value || {}).length && landing) {
        value = {};
        for (const key of campaignFields) if (landing.utm?.[key]) value[`dama_${key}`] = landing.utm[key];
        if (landing.fb) { value.dama_klik = 'fbclid'; value.dama_source ||= 'meta'; }
        if (landing.ids?.gclid) { value.dama_klik = 'gclid'; value.dama_source ||= 'google'; }
      }
    }
    const safe = {};
    for (const key of campaignFields) {
      const text = cleanText(value?.[`dama_${key}`]);
      if (text) safe[`dama_${key}`] = text;
    }
    if (['fbclid', 'gclid'].includes(value?.dama_klik)) safe.dama_klik = value.dama_klik;
    try {
      if (Object.keys(safe).length) sessionStorage.setItem(campaignKey, JSON.stringify(safe));
      else sessionStorage.removeItem(campaignKey);
    } catch (_) {}
    return safe;
  }
  function campaignParameters() {
    const value = campaign(), result = { ...value };
    // DE attribution is derived natively from the consented landing URL and referrer.
    // Keep our custom context, but never replay an older tab campaign as GA4 overrides.
    if (host === 'damacouture.de') return result;
    for (const key of campaignFields) {
      if (value[`dama_${key}`]) result[`campaign_${key === 'campaign' ? 'name' : key}`] = value[`dama_${key}`];
    }
    return result;
  }
  const setDisabled = disabled => Object.values(streams).forEach(id => { window[`ga-disable-${id}`] = disabled; });
  setDisabled(true);
  function blocked() {
    const role = document.body?.dataset.damaThemeRole || window.Shopify?.theme?.role;
    const params = new URLSearchParams(window.location.search);
    return !stream || !window.Shopify || window.Shopify.designMode || window.Shopify.inspectMode ||
      (role && role !== 'main') || params.has('preview_theme_id') || params.has('preview_script_id') || params.has('shopify-pixel-mode') ||
      Boolean(document.getElementById('preview-bar-iframe') || document.getElementById('OnlineStorePreviewBarNextData'));
  }
  if (blocked()) return;
  const landing = (() => {
    const params = new URLSearchParams(window.location.search);
    const tagged = campaignFields.some(key => params.has(`utm_${key}`)) || params.has('fbclid') || landingIds.some(key => params.has(key));
    if (tagged) {
      if (!usablePage()) return null;
      const value = { t: Date.now(), utm: {}, ids: {} };
      for (const key of [...campaignFields, 'source_platform']) {
        const text = cleanText(params.get(`utm_${key}`));
        if (text) value.utm[key] = text;
      }
      for (const key of landingIds) {
        const text = params.get(key) || '';
        if (/^[A-Za-z0-9_.~-]{1,512}$/.test(text)) value.ids[key] = text;
      }
      if (params.has('fbclid')) value.fb = true;
      const referrer = safeLocation(document.referrer);
      if (referrer && !streams[new URL(referrer).hostname.replace(/^www\./, '').toLowerCase()]) value.r = referrer;
      try { sessionStorage.setItem(landingKey, JSON.stringify(value)); } catch (_) {}
      return null;
    }
    let internal = false;
    try { internal = new URL(document.referrer).hostname.replace(/^www\./, '').toLowerCase() === host; } catch (_) {}
    return internal ? readLanding() : null;
  })();
  let privacy, mode = 'idle', ownGtag, consentAllowed = false, pageViewSent = false, listening = false, adConsentSent = null;
  // Google ad consent mirrors the visitor's marketing choice in the Shopify banner.
  function adConsent() {
    const value = marketingAllowed() ? 'granted' : 'denied';
    return { ad_storage: value, ad_user_data: value, ad_personalization: value };
  }
  function syncAdConsent() {
    if ((mode !== 'owned' && mode !== 'existing') || typeof window.gtag !== 'function') return;
    const value = adConsent();
    if (adConsentSent === value.ad_storage) return;
    adConsentSent = value.ad_storage;
    window.gtag('consent', 'update', value);
  }
  let queue = [];
  function allowed() {
    try { return !blocked() && privacy?.analyticsProcessingAllowed() === true; } catch (_) { return false; }
  }
  function usablePage() {
    return !/\/(?:search|account|checkouts?|orders)(?:\/|$)/i.test(window.location.pathname) &&
      !['q', 'query', 'search', 'search_term', 'email', 'phone', 'address'].some(key => new URLSearchParams(window.location.search).has(key));
  }
  function safeLocation(value) {
    if (!value) return '';
    try {
      const url = new URL(value, window.location.origin);
      if (!/^https?:$/.test(url.protocol)) return '';
      if (!streams[url.hostname.replace(/^www\./, '').toLowerCase()]) return url.origin;
      const path = url.pathname.replace(/\/{2,}/g, '/');
      const safe = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:(?:products|collections|pages)\/[a-z0-9-]+(?:\/products\/[a-z0-9-]+)?|blogs\/[a-z0-9-]+(?:\/[a-z0-9-]+)?)?\/?$/i.test(path);
      return url.origin + (safe ? path : '/');
    } catch (_) { return ''; }
  }
  function pageLocation() {
    const sanitized = safeLocation(window.location.href);
    if (host !== 'damacouture.de' || !allowed() || !usablePage()) return sanitized;
    try {
      const source = new URL(window.location.href);
      const target = new URL(sanitized);
      if (source.pathname !== target.pathname) return sanitized;
      for (const key of [...campaignFields, 'source_platform']) {
        const value = cleanText(source.searchParams.get(`utm_${key}`));
        if (value) target.searchParams.set(`utm_${key}`, value);
      }
      for (const key of ['gclid', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid']) {
        const value = source.searchParams.get(key) || '';
        if (/^[A-Za-z0-9_.~-]{1,512}$/.test(value)) target.searchParams.set(key, value);
      }
      if (landing) {
        for (const key of [...campaignFields, 'source_platform']) if (landing.utm?.[key]) target.searchParams.set(`utm_${key}`, landing.utm[key]);
        for (const key of landingIds) if (landing.ids?.[key]) target.searchParams.set(key, landing.ids[key]);
      }
      return target.href;
    } catch (_) { return sanitized; }
  }
  function pageReferrer() {
    return landing?.r || safeLocation(document.referrer);
  }
  function context() {
    const data = document.body?.dataset || {};
    let source = data.damaPageType;
    if (source === 'index') source = 'homepage';
    if (document.querySelector('.dama-store-finder')) source = 'finder';
    if (!sourceTypes.has(source)) source = 'other';
    const value = { source_type: source, locale: /^(de|pl|en|it|fr|es)\b/i.exec(document.documentElement.lang || '')?.[1]?.toLowerCase() || 'en', hostname: window.location.hostname.toLowerCase() };
    if (/^[a-z0-9][a-z0-9-]{0,99}$/.test(data.damaProductHandle || '')) value.product_handle = data.damaProductHandle;
    if (/^\d{1,20}$/.test(data.damaCollectionId || '')) value.collection_id = data.damaCollectionId;
    return value;
  }
  function pageParameters() {
    const value = context();
    return { ...value, ...campaignParameters(), ...internalTrafficParameters(), page_location: pageLocation(), page_referrer: pageReferrer(), page_title: `${value.source_type} | DAMA Couture` };
  }
  function parameters(input = {}, name) {
    const value = pageParameters();
    if (sourceTypes.has(input.source_type)) value.source_type = input.source_type;
    for (const key of ['product_handle', 'collection_id']) delete value[key];
    if (/^[a-z0-9][a-z0-9-]{0,99}$/.test(input.product_handle || '')) value.product_handle = input.product_handle;
    if (/^\d{1,20}$/.test(String(input.collection_id || ''))) value.collection_id = String(input.collection_id);
    if (/^salon_[a-f0-9]{16}$/.test(input.salon_id || '')) value.salon_id = input.salon_id;
    if (['phone', 'website', 'appointment'].includes(input.contact_action) || (['fr', 'es'].includes(value.locale) && input.contact_action === 'email')) value.contact_action = input.contact_action;
    if (['list', 'map'].includes(input.selection_surface)) value.selection_surface = input.selection_surface;
    for (const key of ['item_name', 'item_category', 'salon', 'miasto', 'kraj', 'kod', 'region', 'region_nazwa', 'gdzie', 'skad', 'etykieta']) {
      const text = cleanText(input[key]);
      if (text) value[key] = text;
    }
    if (/^\d{1,20}$/.test(String(input.item_id || ''))) value.item_id = String(input.item_id);
    if (/^[A-Z]{3}$/.test(input.currency || '') && Number.isFinite(input.value) && input.value >= 0) {
      value.currency = input.currency; value.value = input.value;
    }
    if (name === 'view_item' && value.item_id) {
      value.items = [{ item_id: value.item_id, item_name: value.item_name || value.item_id, quantity: 1 }];
      if (value.item_category) value.items[0].item_category = value.item_category;
      if (value.value !== undefined) value.items[0].price = value.value;
    }
    return { ...value, send_to: stream };
  }
  function googleScript() {
    return [...document.querySelectorAll('script[src]')].find(node => {
      try { const url = new URL(node.src); return /(^|\.)googletagmanager\.com$/.test(url.hostname) && /^\/(gtag\/js|gtm\.js)$/.test(url.pathname); }
      catch (_) { return false; }
    });
  }
  function invoke(name, values) {
    if (!allowed() || !usablePage() || window[`ga-disable-${stream}`] || typeof window.gtag !== 'function') return false;
    window.gtag('event', name, { ...values, ...internalTrafficParameters() });
    return true;
  }
  function flush() {
    if (!allowed()) { queue = []; return; }
    const pending = queue; queue = [];
    pending.forEach(([name, values]) => invoke(name, values));
  }
  function ensureGoogle() {
    if (!allowed() || !usablePage()) return false;
    if (mode === 'owned-paused') { startOwned(); return true; }
    if (mode === 'owned-loading' || mode === 'owned' || mode === 'failed') return mode !== 'failed';
    if (mode === 'existing' && typeof window.gtag === 'function') return true;
    const existing = googleScript(), callable = typeof window.gtag === 'function' && window.gtag !== ownGtag;
    if (existing || callable) {
      mode = existing && callable ? 'existing' : 'external-waiting';
      if (mode === 'existing') {
        // Future commands only: earlier events from an external initializer are not covered.
        if (internalBrowser) window.gtag('set', internalTrafficParameters());
        window.gtag('consent', 'update', { analytics_storage: 'granted', ...adConsent() });
        adConsentSent = adConsent().ad_storage;
        clearLanding();
        flush();
      }
      return mode === 'existing';
    }
    mode = 'owned-loading';
    window.dataLayer = window.dataLayer || [];
    ownGtag = function () { window.dataLayer.push(arguments); };
    window.gtag = ownGtag;
    ownGtag('consent', 'default', { analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
    const script = document.createElement('script');
    script.id = 'dama-google-tag'; script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${tagId}`;
    script.onload = startOwned;
    script.onerror = () => { mode = 'failed'; queue = []; };
    document.head.appendChild(script);
    return true;
  }
  function startOwned() {
      if (!allowed() || !usablePage()) { mode = 'owned-paused'; queue = []; return; }
      mode = 'owned';
      ownGtag('js', new Date());
      ownGtag('set', { ...internalTrafficParameters(), page_location: pageLocation(), page_referrer: pageReferrer(), allow_google_signals: false, allow_ad_personalization_signals: false });
      ownGtag('consent', 'update', { analytics_storage: 'granted', ...adConsent() });
      adConsentSent = adConsent().ad_storage;
      ownGtag('config', tagId, { send_page_view: false, ...pageParameters(), allow_google_signals: false, allow_ad_personalization_signals: false });
      if (!pageViewSent) pageViewSent = invoke('page_view', { ...pageParameters(), send_to: stream });
      if (pageViewSent) clearLanding();
      flush();
  }
  function track(name, input) {
    if (!names.has(name) || !allowed() || !usablePage()) return false;
    const values = parameters(input, name);
    if (['dama_salon_selected', 'dama_salon_contact_clicked'].includes(name) && !values.salon_id) return false;
    if (name === 'dama_salon_contact_clicked' && !values.contact_action) return false;
    if (name === 'view_item' && !values.item_id) return false;
    if (!ensureGoogle()) return false;
    if (mode === 'owned-loading') { if (queue.length >= 30) return false; queue.push([name, values]); return true; }
    return invoke(name, values);
  }
  window.DamaAnalytics = Object.freeze({ track, context, campaign, marketingAllowed, allowed: () => allowed() && usablePage(), status: () => ({ mode, stream, consent: allowed(), deliveryVerified: false }) });
  function sync() {
    const analytics = allowed() && usablePage();
    if (!analytics && !marketingAllowed()) clearCampaign();
    try { if (privacy?.currentVisitorConsent?.()?.analytics === 'no') clearLanding(); } catch (_) {}
    setDisabled(!analytics);
    if (!analytics) {
      queue = [];
      if (consentAllowed && typeof window.gtag === 'function') window.gtag('consent', 'update', { analytics_storage: 'denied' });
    } else {
      if ((mode === 'owned' || mode === 'existing') && !consentAllowed) window.gtag('consent', 'update', { analytics_storage: 'granted' });
      ensureGoogle();
    }
    syncAdConsent();
    if (consentAllowed !== analytics) { consentAllowed = analytics; document.dispatchEvent(new CustomEvent('dama:analytics-consent', { detail: { allowed: analytics } })); }
  }
  function ready() {
    privacy = window.Shopify.customerPrivacy;
    if (!privacy) return;
    if (!listening) { document.addEventListener('visitorConsentCollected', sync); listening = true; }
    sync();
    document.dispatchEvent(new CustomEvent('dama:tracking-ready'));
  }
  if (window.Shopify.customerPrivacy) ready();
  else if (window.Shopify.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) ready(); });
})();

(() => {
  'use strict';
  // The French and Spanish rollouts exclude these integrations; other locales retain their existing consent rules.
  if (/^(?:fr|es)(?:-|$)/i.test(document.documentElement.lang || '') || /(^|\.)damacouture\.(?:fr|es)$/i.test(window.location.hostname)) return;
  if (!window.DamaAnalytics || window.__damaMarketingStarted) return;
  window.__damaMarketingStarted = true;
  let privacy;
  let apolloStarted = false;
  let reloading = false;
  const allowed = purpose => {
    try {
      return purpose === 'analytics' ? privacy?.analyticsProcessingAllowed() === true : privacy?.marketingAllowed() === true;
    } catch (_) { return false; }
  };
  function script(id, src, onload) {
    if (document.getElementById(id)) return;
    const node = document.createElement('script');
    node.id = id;
    node.src = src;
    node.async = true;
    if (onload) node.onload = onload;
    document.head.appendChild(node);
  }
  function syncTrackers() {
    const marketing = allowed('marketing');
    if (apolloStarted && !marketing) {
      if (!reloading) {
        reloading = true;
        window.location.reload();
      }
      return;
    }
    if (marketing && !apolloStarted) {
      apolloStarted = true;
      script('dama-apollo-tracker', 'https://assets.apollo.io/micro/website-tracker/tracker.iife.js', () => {
        if (allowed('marketing')) window.trackingFunctions?.onLoad({appId: '67250e1db12c2e03ef7f4464'});
      });
    }
  }
  function ready() {
    privacy = window.Shopify.customerPrivacy;
    if (!privacy) return;
    syncTrackers();
    document.addEventListener('visitorConsentCollected', syncTrackers);
  }
  if (window.Shopify.customerPrivacy) ready();
  else if (window.Shopify.loadFeatures) window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => { if (!error) ready(); });
})();

